import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('EpicProfile').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',

    width: '100%',

    alignItems: 'center',
    overflowX: 'hidden',
    overflowY: 'scroll',
    position: 'relative',
    paddingBottom: '27vh',
  },

  headerContainer: {
    width: '100%',
    height: '200px',
    background: theme.colors.background.secondary,
  },

  bannerContainer: {
    justifyContent: 'center',
    position: 'relative',
    minHeight: '200px',
    maxHeight: '200px',
    backgroundImage: 'url(/assets/backgrounds/egsprofilebg.webp)',
    backgroundSize: '100%',
    backgroundPositionY: '0px',
    width: '100%',
  },

  bannerImg: {
    width: '100%',
    height: '200px',
    filter: 'brightness(65%)',
  },

  connectedText: {
    zIndex: 2,
    color: theme.colors.text.success,
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: '350',
    lineHeight: '18px',
    letterSpacing: '-0.13px',
    position: 'absolute',
    bottom: '20px',
    width: '100%',
  },

  contentWrapper: {
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },

  statsList: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'repeat(4, auto)',
    gap: '16px',
  },
  buttonsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  button: {
    height: '52px',
  },

  favgamesWrapper: {
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
  },

  title: {
    color: theme.colors.text.primary,
    fontSize: theme.sizes.texts.fontSize.l,
    fontWeight: 500,
    lineHeight: theme.sizes.texts.fontSize.l,
    margin: 0,

    paddingTop: theme.sizes.texts.fontSize.s,
    textAlign: 'left',
    alignSelf: 'start',
  },

  noGames: {
    color: theme.colors.text.secondary,
    fontSize: theme.sizes.texts.fontSize.m,
    fontWeight: 400,
    lineHeight: theme.sizes.texts.fontSize.m,
    margin: 0,
    textAlign: 'center',
    width: '100%',
    paddingTop: theme.sizes.texts.fontSize.xl,
    alignSelf: 'start',
  },
}))
